<p class="cp-assign__cards">
  {{ 'compositeProducts.assign.cards' | transloco }}: <b>{{ data.cards.length }}</b>
  <span class="cp-assign__titles">{{ cardsText }}</span>
</p>

@if (severalCountries) {
  <nz-alert nzType="error" nzShowIcon [nzMessage]="'compositeProducts.assign.severalCountries' | transloco"></nz-alert>
} @else if (assigned === undefined) {
  @if (country) {
    <p class="cp-assign__country">{{ 'compositeProducts.assign.country' | transloco }}: <b>{{ country.title | uiLabel }}</b></p>
  }
  <nz-radio-group class="cp-assign__mode" [(ngModel)]="mode" (ngModelChange)="onChoice()">
    <label nz-radio nzValue="set">{{ 'compositeProducts.assign.set' | transloco }}</label>
    <label nz-radio nzValue="clear">{{ 'compositeProducts.assign.clear' | transloco }}</label>
  </nz-radio-group>

  @if (mode === 'set') {
    @if (noSections) {
      <nz-alert nzType="warning" nzShowIcon [nzMessage]="'compositeProducts.assign.noSections' | transloco"></nz-alert>
    } @else {
      <nz-form-item>
        <nz-form-label nzRequired>{{ 'compositeProducts.assign.section' | transloco }}</nz-form-label>
        <nz-form-control [nzExtra]="'compositeProducts.assign.sectionHint' | transloco">
          <nz-select nzShowSearch [nzPlaceHolder]="'compositeProducts.assign.sectionPlaceholder' | transloco" [(ngModel)]="sectionId" (ngModelChange)="onChoice()">
            @for (option of options; track option.id) {
              <nz-option [nzValue]="option.id" [nzLabel]="option.text"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    }
  }
} @else {
  <nz-alert nzType="success" nzShowIcon [nzMessage]="'compositeProducts.assign.done' | transloco: {count: assigned}"></nz-alert>
  @if (skipped.length > 0) {
    <nz-alert class="cp-assign__skipped" nzType="warning" nzShowIcon [nzMessage]="'compositeProducts.assign.skipped' | transloco: {count: skipped.length}"
              [nzDescription]="skippedList"></nz-alert>
    <ng-template #skippedList>
      <ul>
        @for (row of skipped; track row.id) {
          <li>{{ row.title }} <span class="cp-assign__titles">— {{ row.reason }}</span></li>
        }
      </ul>
    </ng-template>
  }
}

<div *nzModalFooter>
  @if (assigned === undefined) {
    <button nz-button nzType="default" type="button" (click)="modalRef.close()">{{ 'button.cancel' | transloco }}</button>
    <button nz-button nzType="primary" type="button" [nzLoading]="isSaving" [disabled]="isSaving || severalCountries || !ready" (click)="submit()">
      {{ 'compositeProducts.assign.submit' | transloco }}
    </button>
  } @else {
    <button nz-button nzType="primary" type="button" (click)="modalRef.close('success')">{{ 'button.close' | transloco }}</button>
  }
</div>
